import React from "react";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";

import { AppBar, Box, IconButton, Toolbar, Tooltip } from "@mui/material";
import Notification from "../../../components/Notification";
import GoogleTranslate from "../../../components/GoogleTranslate";
import { useColorMode } from "../../../contexts/ColorModeContext";

const Header = (props) => {
  const { mode, toggleColorMode } = useColorMode();
  const isDark = mode === "dark";

  return (
    <AppBar
      sx={{
        ...props.sx,
        backgroundColor: (theme) => theme.palette.background.paper,
        color: (theme) => theme.palette.text.primary,
      }}
      elevation={0}
      className={props.customClass}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          onClick={props.toggleMobileSidebar}
          sx={{
            display: {
              lg: "none",
              xs: "inline",
            },
          }}
        >
          <MenuOutlinedIcon width="20" height="20" />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: 2,
            width: "100%",
          }}
        >
          <GoogleTranslate />

          <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
            <IconButton color="inherit" onClick={toggleColorMode}>
              {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
          </Tooltip>

          <Notification />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
